var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAppleQr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1667 1667",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1410.17,3.833l-1154.11,0c-0.075,0 -0.149,-0 -0.223,-0c-34.378,-0 -62.667,28.289 -62.667,62.667c0,0.055 0.001,0.111 0.001,0.167l-0,1154.61c0.06,34.467 28.421,62.803 62.889,62.833l1154.56,0c34.467,-0.03 62.828,-28.366 62.889,-62.833l0,-1154.61c-0.303,-34.543 -28.789,-62.805 -63.333,-62.834Zm14.666,1197.72c0,0.018 0,0.037 0,0.055c0,18.591 -15.298,33.889 -33.889,33.889c-0.018,0 -0.037,0 -0.055,0l-1115.61,0c-0.019,0 -0.037,0 -0.056,0c-18.591,0 -33.889,-15.298 -33.889,-33.889c0,-0.018 0,-0.037 0,-0.055l0,-1115.61c0,-0.018 0,-0.037 0,-0.055c0,-18.591 15.298,-33.889 33.889,-33.889c0.019,-0 0.037,-0 0.056,0l1115.61,0c0.037,-0 0.074,-0 0.111,-0c18.561,-0 33.834,15.273 33.834,33.833c-0,0.037 -0.001,0.074 -0.001,0.111l0,1115.61Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "IconCircleOutline",
    d: "M357.889,1367.17c-71.607,0.152 -130.445,59.114 -130.445,130.722c0,71.712 59.011,130.722 130.723,130.722c71.712,-0 130.722,-59.01 130.722,-130.722c0,-0.111 0,-0.223 0,-0.334c0,-71.529 -58.859,-130.389 -130.389,-130.389c-0.111,0 -0.222,0 -0.333,0.001l-0.278,-0Z",
    style: {
      fillOpacity: 0,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "PhoneIcon",
    d: "M414.278,1414.39l-0,165.167c-0.031,10.289 -8.488,18.747 -18.778,18.777l-81.222,0c-10.29,-0.03 -18.748,-8.488 -18.778,-18.777l0,-165.167c0.03,-10.29 8.488,-18.748 18.778,-18.778l81.222,0c10.211,0.234 18.544,8.567 18.778,18.778Zm-83.945,0.944c-0.001,4.723 3.834,8.632 8.556,8.723l31.222,-0c4.764,-0.031 8.667,-3.959 8.667,-8.723c-0.142,-4.708 -3.959,-8.55 -8.667,-8.722l-30.611,0c-0.111,-0.004 -0.223,-0.006 -0.334,-0.006c-4.806,-0 -8.776,3.922 -8.833,8.728Zm69.667,21.556l-91.278,-0.945l0,122.223l91.278,-0l0,-121.278Zm-57.778,141.278c0,6.796 5.593,12.389 12.389,12.389c6.796,-0 12.389,-5.593 12.389,-12.389c0,-6.797 -5.593,-12.389 -12.389,-12.389c0,-0 0,-0 -0,-0c-6.766,-0 -12.333,5.567 -12.333,12.333c-0,0.019 -0,0.037 -0,0.056l-0.056,-0Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "PhoneIconBlack",
    d: "M414.278,1414.39l-0,165.167c-0.031,10.289 -8.488,18.747 -18.778,18.777l-81.222,0c-10.29,-0.03 -18.748,-8.488 -18.778,-18.777l0,-165.167c0.03,-10.29 8.488,-18.748 18.778,-18.778l81.222,0c10.211,0.234 18.544,8.567 18.778,18.778Zm-83.945,0.944c-0.001,4.723 3.834,8.632 8.556,8.723l31.222,-0c4.764,-0.031 8.667,-3.959 8.667,-8.723c-0.142,-4.708 -3.959,-8.55 -8.667,-8.722l-30.611,0c-0.111,-0.004 -0.223,-0.006 -0.334,-0.006c-4.806,-0 -8.776,3.922 -8.833,8.728Zm69.667,21.556l-91.278,-0.945l0,122.223l91.278,-0l0,-121.278Zm-57.778,141.278c0,6.796 5.593,12.389 12.389,12.389c6.796,-0 12.389,-5.593 12.389,-12.389c0,-6.797 -5.593,-12.389 -12.389,-12.389c0,-0 0,-0 -0,-0c-6.766,-0 -12.333,5.567 -12.333,12.333c-0,0.019 -0,0.037 -0,0.056l-0.056,-0Z",
    style: {
      fillOpacity: 0,
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1308.33,1333.33l-950.444,0c-90.455,0 -164.889,74.434 -164.889,164.889c-0,90.456 74.434,164.889 164.889,164.889l950,0c0.074,0 0.148,0 0.222,0c90.456,0 164.889,-74.433 164.889,-164.889c0,-90.371 -74.295,-164.767 -164.667,-164.889Zm-950.444,295.278c-71.607,-0.152 -130.445,-59.115 -130.445,-130.722c0,-71.712 59.011,-130.722 130.723,-130.722c71.712,-0 130.722,59.01 130.722,130.722c0,0.111 0,0.223 0,0.335c0,71.529 -58.859,130.389 -130.389,130.389c-0.203,-0 -0.407,-0.001 -0.611,-0.002Z",
    style: {
      fillRule: "nonzero"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.583,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.583,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.583,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 544.583,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 582.75,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 620.917,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 355.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 659.083,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.25,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.25,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.25,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.25,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.25,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 697.25,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 355.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 735.417,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 773.583,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 811.75,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 355.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 849.917,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 888.083,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 926.25,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 355.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 964.417,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1002.58,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040.75,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1078.92,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 432.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 737.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 775.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 393.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 470.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 546.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 622.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 661.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 813.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 508.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 584.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 699.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 851.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 890.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.583,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.583,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 317.528,
    width: 38.167,
    height: 38.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 241.194,
    width: 38.167,
    height: 38.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1117.08,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1155.25,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1307.92,
    y: 317.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 88.528,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 126.694,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 279.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1346.08,
    y: 317.528,
    width: 38.167,
    height: 38.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1193.42,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1231.58,
    y: 241.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 164.861,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 203.028,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1269.75,
    y: 241.194,
    width: 38.167,
    height: 38.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.417,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.583,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.583,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 468.25,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 928.194,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 966.361,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 1119.03,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 506.417,
    y: 1157.19,
    width: 38.167,
    height: 38.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.75,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 391.917,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 1004.53,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 1042.69,
    width: 38.167,
    height: 38.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 430.083,
    y: 1080.86,
    width: 38.167,
    height: 38.167
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#_Image1",
    x: 0,
    y: 0,
    width: "250px",
    height: "290px",
    transform: "matrix(1.0076,0,0,1.01339,704.883,495.003)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M668.641,1501.29l-26.475,-0l-5.946,16.493l-8.594,-0l24.132,-63.195l7.291,0l24.176,63.195l-8.551,-0l-6.033,-16.493Zm-23.958,-6.858l21.485,0l-10.764,-29.557l-10.721,29.557Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.143,1494.82c0,7.147 -1.635,12.905 -4.904,17.274c-3.27,4.369 -7.697,6.554 -13.282,6.554c-5.7,-0 -10.185,-1.809 -13.454,-5.426l-0,22.613l-8.03,0l0,-65.017l7.335,-0l0.391,5.208c3.269,-4.051 7.812,-6.076 13.628,-6.076c5.643,-0 10.106,2.127 13.39,6.38c3.284,4.254 4.926,10.171 4.926,17.752l0,0.738Zm-8.029,-0.912c-0,-5.295 -1.129,-9.476 -3.386,-12.543c-2.257,-3.067 -5.353,-4.601 -9.288,-4.601c-4.861,0 -8.507,2.156 -10.937,6.467l-0,22.439c2.401,4.283 6.076,6.424 11.024,6.424c3.848,0 6.908,-1.526 9.18,-4.579c2.271,-3.053 3.407,-7.588 3.407,-13.607Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M780.013,1494.82c0,7.147 -1.635,12.905 -4.904,17.274c-3.27,4.369 -7.697,6.554 -13.282,6.554c-5.7,-0 -10.185,-1.809 -13.455,-5.426l0,22.613l-8.029,0l-0,-65.017l7.335,-0l0.391,5.208c3.269,-4.051 7.812,-6.076 13.628,-6.076c5.642,-0 10.106,2.127 13.39,6.38c3.284,4.254 4.926,10.171 4.926,17.752l0,0.738Zm-8.029,-0.912c-0,-5.295 -1.129,-9.476 -3.386,-12.543c-2.257,-3.067 -5.353,-4.601 -9.288,-4.601c-4.861,0 -8.507,2.156 -10.938,6.467l0,22.439c2.402,4.283 6.077,6.424 11.025,6.424c3.848,0 6.908,-1.526 9.179,-4.579c2.272,-3.053 3.408,-7.588 3.408,-13.607Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 790.907,
    y: 1451.11,
    width: 8.03,
    height: 66.667,
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M831.272,1518.65c-6.366,-0 -11.545,-2.091 -15.538,-6.272c-3.994,-4.181 -5.99,-9.773 -5.99,-16.775l-0,-1.476c-0,-4.658 0.89,-8.818 2.669,-12.478c1.78,-3.66 4.268,-6.525 7.465,-8.594c3.198,-2.069 6.663,-3.103 10.395,-3.103c6.106,-0 10.851,2.011 14.237,6.033c3.385,4.022 5.078,9.78 5.078,17.274l-0,3.342l-31.815,0c0.116,4.63 1.469,8.37 4.059,11.22c2.589,2.85 5.881,4.275 9.874,4.275c2.835,0 5.237,-0.579 7.205,-1.736c1.967,-1.158 3.689,-2.691 5.165,-4.601l4.904,3.82c-3.935,6.047 -9.838,9.071 -17.708,9.071Zm-0.999,-42.101c-3.24,0 -5.96,1.179 -8.159,3.537c-2.199,2.359 -3.559,5.665 -4.08,9.918l23.524,0l0,-0.608c-0.231,-4.079 -1.331,-7.241 -3.298,-9.483c-1.968,-2.243 -4.63,-3.364 -7.987,-3.364Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.036,1501.29l-26.476,-0l-5.946,16.493l-8.594,-0l24.132,-63.195l7.292,0l24.175,63.195l-8.55,-0l-6.033,-16.493Zm-23.959,-6.858l21.485,0l-10.764,-29.557l-10.721,29.557Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M978.537,1494.82c0,7.147 -1.635,12.905 -4.904,17.274c-3.27,4.369 -7.697,6.554 -13.281,6.554c-5.701,-0 -10.186,-1.809 -13.455,-5.426l-0,22.613l-8.03,0l0,-65.017l7.335,-0l0.391,5.208c3.27,-4.051 7.812,-6.076 13.628,-6.076c5.643,-0 10.106,2.127 13.39,6.38c3.284,4.254 4.926,10.171 4.926,17.752l0,0.738Zm-8.029,-0.912c-0,-5.295 -1.129,-9.476 -3.386,-12.543c-2.257,-3.067 -5.353,-4.601 -9.288,-4.601c-4.861,0 -8.507,2.156 -10.937,6.467l-0,22.439c2.401,4.283 6.076,6.424 11.024,6.424c3.848,0 6.908,-1.526 9.18,-4.579c2.271,-3.053 3.407,-7.588 3.407,-13.607Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1028.41,1494.82c0,7.147 -1.635,12.905 -4.904,17.274c-3.27,4.369 -7.697,6.554 -13.282,6.554c-5.7,-0 -10.185,-1.809 -13.455,-5.426l0,22.613l-8.029,0l-0,-65.017l7.335,-0l0.391,5.208c3.269,-4.051 7.812,-6.076 13.628,-6.076c5.643,-0 10.106,2.127 13.39,6.38c3.284,4.254 4.926,10.171 4.926,17.752l0,0.738Zm-8.029,-0.912c-0,-5.295 -1.129,-9.476 -3.386,-12.543c-2.257,-3.067 -5.353,-4.601 -9.288,-4.601c-4.861,0 -8.507,2.156 -10.938,6.467l0,22.439c2.402,4.283 6.077,6.424 11.025,6.424c3.848,0 6.908,-1.526 9.179,-4.579c2.272,-3.053 3.408,-7.588 3.408,-13.607Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1080.49,1489.61c-7.147,-2.054 -12.348,-4.579 -15.603,-7.573c-3.255,-2.995 -4.883,-6.692 -4.883,-11.09c0,-4.977 1.99,-9.093 5.968,-12.348c3.979,-3.255 9.151,-4.883 15.517,-4.883c4.34,0 8.21,0.839 11.61,2.518c3.4,1.678 6.033,3.993 7.899,6.944c1.867,2.951 2.8,6.178 2.8,9.679l-8.377,-0c0,-3.82 -1.215,-6.822 -3.646,-9.006c-2.43,-2.185 -5.859,-3.277 -10.286,-3.277c-4.109,-0 -7.314,0.904 -9.614,2.713c-2.3,1.808 -3.451,4.318 -3.451,7.53c0,2.575 1.093,4.753 3.277,6.532c2.185,1.78 5.903,3.407 11.155,4.883c5.252,1.476 9.36,3.103 12.326,4.883c2.966,1.779 5.165,3.855 6.598,6.228c1.432,2.373 2.148,5.165 2.148,8.377c-0,5.121 -1.997,9.223 -5.99,12.304c-3.993,3.082 -9.331,4.623 -16.015,4.623c-4.341,-0 -8.391,-0.832 -12.153,-2.496c-3.762,-1.664 -6.662,-3.942 -8.702,-6.836c-2.04,-2.893 -3.06,-6.177 -3.06,-9.852l8.377,-0c-0,3.819 1.41,6.836 4.231,9.049c2.822,2.214 6.59,3.321 11.307,3.321c4.398,-0 7.769,-0.897 10.113,-2.691c2.343,-1.794 3.515,-4.239 3.515,-7.335c0,-3.097 -1.085,-5.491 -3.255,-7.184c-2.17,-1.692 -6.105,-3.363 -11.806,-5.013Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1124.24,1459.44l0,11.372l8.768,-0l-0,6.207l-8.768,-0l0,29.123c0,1.881 0.391,3.291 1.172,4.232c0.782,0.94 2.113,1.41 3.993,1.41c0.926,0 2.199,-0.173 3.82,-0.521l-0,6.511c-2.112,0.578 -4.167,0.868 -6.163,0.868c-3.588,-0 -6.294,-1.085 -8.117,-3.255c-1.823,-2.171 -2.734,-5.252 -2.734,-9.245l-0,-29.123l-8.55,-0l-0,-6.207l8.55,-0l-0,-11.372l8.029,0Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1139.39,1493.86c0,-4.601 0.904,-8.739 2.713,-12.413c1.808,-3.675 4.326,-6.511 7.552,-8.507c3.226,-1.997 6.908,-2.995 11.046,-2.995c6.394,-0 11.567,2.213 15.516,6.641c3.95,4.427 5.925,10.315 5.925,17.664l-0,0.565c-0,4.571 -0.876,8.673 -2.626,12.304c-1.751,3.632 -4.254,6.46 -7.509,8.486c-3.255,2.025 -6.995,3.038 -11.219,3.038c-6.366,-0 -11.524,-2.214 -15.473,-6.641c-3.95,-4.427 -5.925,-10.286 -5.925,-17.578l0,-0.564Zm8.073,0.955c-0,5.208 1.208,9.389 3.624,12.543c2.416,3.154 5.65,4.731 9.701,4.731c4.079,0 7.32,-1.599 9.722,-4.796c2.401,-3.197 3.602,-7.675 3.602,-13.433c0,-5.151 -1.222,-9.325 -3.667,-12.522c-2.445,-3.197 -5.693,-4.796 -9.744,-4.796c-3.964,0 -7.162,1.577 -9.592,4.731c-2.431,3.154 -3.646,7.668 -3.646,13.542Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1214.91,1478.02c-1.215,-0.203 -2.532,-0.304 -3.95,-0.304c-5.266,0 -8.839,2.242 -10.72,6.727l-0,33.334l-8.03,-0l0,-46.962l7.813,-0l0.13,5.425c2.633,-4.195 6.366,-6.293 11.198,-6.293c1.562,-0 2.749,0.202 3.559,0.608l-0,7.465Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.95,1518.65c-6.366,-0 -11.546,-2.091 -15.539,-6.272c-3.993,-4.181 -5.989,-9.773 -5.989,-16.775l-0,-1.476c-0,-4.658 0.889,-8.818 2.669,-12.478c1.78,-3.66 4.268,-6.525 7.465,-8.594c3.198,-2.069 6.663,-3.103 10.395,-3.103c6.106,-0 10.851,2.011 14.236,6.033c3.386,4.022 5.078,9.78 5.078,17.274l0,3.342l-31.814,0c0.116,4.63 1.469,8.37 4.058,11.22c2.59,2.85 5.881,4.275 9.875,4.275c2.835,0 5.237,-0.579 7.204,-1.736c1.968,-1.158 3.69,-2.691 5.165,-4.601l4.905,3.82c-3.935,6.047 -9.838,9.071 -17.708,9.071Zm-0.999,-42.101c-3.24,0 -5.96,1.179 -8.159,3.537c-2.2,2.359 -3.559,5.665 -4.08,9.918l23.524,0l-0,-0.608c-0.232,-4.079 -1.331,-7.241 -3.299,-9.483c-1.967,-2.243 -4.629,-3.364 -7.986,-3.364Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    id: "_Image1",
    width: "250px",
    height: "290px",
    xlinkHref: "data:image/png;base64,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"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleQr);
export default __webpack_public_path__ + "static/media/appleQR.d1969e617901b5789447a0519b0412a9.svg";
export { ForwardRef as ReactComponent };